<template>
  <b-modal
    :active.sync="show"
    trap-focus
    aria-role="dialog"
    scroll="keep"
    :width="1000"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form @submit.prevent="passes(save)">
        <div class="modal-card" style="width: 1000px">
          <header class="modal-card-head">
            <p class="modal-card-title">Edit Sequence</p>
          </header>
          <section class="modal-card-body">
            <label class="has-text-weight-bold">Sequence Items</label>
            <div v-for="item in scheduleItems" :key="item.id">
              <b-checkbox
                v-model="item.selected"
                style="position: relative; top: 4px"
              />
              {{ getTitle(item) }}
              {{ formatTime(item.start_time) }} -
              {{ formatTime(item.end_time) }}
              <a
                href=""
                @click.prevent="removeItem(item)"
                style="top: 3px; position: relative"
                ><b-icon icon="close"></b-icon
              ></a>
            </div>
          </section>
          <footer class="modal-card-foot" style="display: block">
            <button class="button" type="button" @click="closeModal">
              Cancel
            </button>
            <button
              class="button is-primary"
              type="button"
              @click="changeTitle()"
            >
              Change Title
            </button>
            <button
              class="button is-primary"
              type="button"
              @click="copySequence()"
            >
              Copy
            </button>
            <button
              class="button is-info is-pulled-right has-margin-right-5"
              :loading="loading"
              @click.prevent="confirmDelete"
            >
              Delete Sequence
            </button>
            <button
              v-if="anySelected"
              class="button is-info is-pulled-right has-margin-right-5"
              :loading="loading"
              @click.prevent="confirmDeleteItems"
            >
              Delete Sequence Items
            </button>
          </footer>
        </div>
      </form>
    </ValidationObserver>
    <ChangeSequenceTitleModal
      :repeats-id="repeatsId"
      :channel-id="channelId"
      :show="showChangeSequenceTitleModal"
      @close-modal="showChangeSequenceTitleModal = false"
      @refresh="
        $emit('refresh')
        showModal = false
        $emit('close-modal')
      "
    ></ChangeSequenceTitleModal>
    <CopySequenceModal
      :repeats-id="repeatsId"
      :show="showCopySequenceModal"
      @close-modal="showCopySequenceModal = false"
      @refresh="
        $emit('refresh')
        showModal = false
        $emit('close-modal')
      "
    ></CopySequenceModal>
  </b-modal>
</template>

<script>
import { sortBy } from 'lodash'
import ChangeSequenceTitleModal from '@/components/ChangeSequenceTitleModal'
import CopySequenceModal from '@/components/CopySequenceModal'
import BaseDateTimePicker from '@/components/BaseDateTimePicker'
import BaseSelect from '@/components/BaseSelect'
import MediaChannelApi from '@/api/mediaChannels'
import EpisodesApi from '@/api/episodes'
import ScheduleApi from '@/api/schedules'
import Filters from '@/mixins/filters'
import Utils from '@/mixins/utils'
import { format } from 'date-fns'

export default {
  name: 'EditSequenceModal',
  components: {
    BaseDateTimePicker,
    BaseSelect,
    ChangeSequenceTitleModal,
    CopySequenceModal,
  },
  mixins: [Filters, Utils],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    channelId: {
      type: Number,
      default: null,
    },
    repeatsId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      initialized: false,
      showModal: this.show,
      scheduleItems: [],
      repeatsInfo: {},
      showChangeSequenceTitleModal: false,
      showCopySequenceModal: false,
    }
  },
  computed: {
    anySelected() {
      if (this.scheduleItems && this.scheduleItems.length > 0) {
        return this.scheduleItems.find((item) => item.selected)
      }
      return false
    },
  },
  watch: {},
  async created() {
    this.repeatsInfo = await ScheduleApi.fetchSequence(this.repeatsId)
    this.scheduleItems = await ScheduleApi.fetchSequenceItems(this.repeatsId)
    this.scheduleItems.forEach((item) => {
      if (item.mediadata) {
        item.mediadata = JSON.parse(item.mediadata)
      }
    })
  },
  methods: {
    removeItem(item) {
      let vm = this
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this item?',
        onConfirm: async () => {
          vm.loading = true
          vm.scheduleItems = vm.scheduleItems.filter((i) => i.id !== item.id)
          await ScheduleApi.remove(item)
          vm.$buefy.toast.open({
            message: 'Item removed successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          vm.loading = false
        },
      })
    },
    copySequence() {
      this.showCopySequenceModal = true
    },
    changeTitle() {
      this.showChangeSequenceTitleModal = true
    },
    getTitle(item) {
      if (item.media_type === 'movie') {
        return item.media_title
      } else {
        return `${item.media_title} S${item.mediadata.seriesNo} E${item.episode_number}`
      }
    },
    formatTime(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm')
    },
    save() {},
    confirmDeleteItems() {
      let items = this.scheduleItems.filter((item) => item.selected)
      this.$buefy.dialog.confirm({
        message: `Are you sure you want to delete the ${items.length} items?`,
        onConfirm: async () => {
          this.loading = true
          await ScheduleApi.removeMultiple(items.map((item) => item.id))
          this.$buefy.toast.open({
            message: 'Items removed successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          this.loading = false
          this.scheduleItems = this.scheduleItems.filter(
            (item) => !item.selected
          )
        },
      })
    },
    confirmDelete() {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this sequence?',
        onConfirm: async () => {
          this.loading = true
          await ScheduleApi.deleteSequence(this.repeatsId)
          this.$buefy.toast.open({
            message: 'Sequence removed successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          this.loading = false
          this.$emit('refresh')
          this.closeModal()
        },
      })
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    },
  },
}
</script>
